export function priceParts(price, localeIso) {
  try {
    const parts = new Intl.NumberFormat(localeIso, {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2,
    }).formatToParts(price)

    let before = ''
    let decimal = ''
    let fraction = ''
    let after = ''
    let reachedFraction = false

    for (const part of parts) {
      if (part.type === 'decimal') {
        decimal = part.value
        reachedFraction = true
        continue
      }
      if (part.type === 'fraction') {
        fraction = part.value
        continue
      }
      if (reachedFraction) {
        after += part.value
      } else {
        before += part.value
      }
    }

    return {
      before: before.trimStart(),
      decimal,
      fraction,
      after: after.trimEnd(),
    }
  } catch (e) {
    const [int, dec] = price.toFixed(2).split('.')
    return { before: int, decimal: ',', fraction: dec, after: '\u00A0€' }
  }
}
